import { useRouterStore } from '@/store-pinia/router';
import isMobile from '../../utils/is-mobile';
const DEFAULT_VIEW = 'root';

const DELAY_INSTANT = 0;
const DELAY_NORMAL = 400;

export default {
  methods: {
    redirect(view = DEFAULT_VIEW, ...options) {
      let delay = DELAY_NORMAL,
        when = 'mobile';
      options.forEach(value => {
        switch (value) {
          case 'instant':
            delay = DELAY_INSTANT;
            break;
          case 'mobile':
            when = 'mobile';
            break;
          case 'always':
            when = 'always';
            break;
          default:
            if (Number.isInteger(value)) {
              delay = value;
            }
        }
      });

      if ('none' === view || ('mobile' === when && !isMobile())) {
        return;
      }

      setTimeout(() => {
        useRouterStore().currentRoute = DEFAULT_VIEW === view ? null : view;
      }, delay);
    },
    redirectAfter(callable, view = DEFAULT_VIEW, ...options) {
      callable();
      this.redirect(view, ...options);
    },
    openModal(view, ...options) {
      this.redirect(view, ...options);
    },
    closeModal(...options) {
      this.redirect(DEFAULT_VIEW, ...options);
    },
    closeModalAfter(callable, ...options) {
      this.redirectAfter(callable, DEFAULT_VIEW, ...options);
    }
  }
};
